import { render } from "./IconTV.vue?vue&type=template&id=6c764e5e"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconTV.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c764e5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c764e5e', __exports__)) {
    api.reload('6c764e5e', __exports__)
  }
  
  module.hot.accept("./IconTV.vue?vue&type=template&id=6c764e5e", () => {
    api.rerender('6c764e5e', render)
  })

}


export default __exports__